import {
    ACTIVE,
    ADTA_ASSET_TYPE,
    ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE, ALL_CONFIG,
    ENDPOINT_GET_ADTA_STATUS, INACTIVE, LOADING_FAILED, LOADING_STRING
} from "../../../util/Constants";
import {
    checkNullAndUndefinedAttribute,
    convertTableJsonToAsset,
    getAPIGatewayPostRequest,
    getNodeId,
    logOperationalMetric
} from "../../../util/Util";
import {addAsset, getAssetByAssetLabel, getAssets, setAssetStatus, updateAsset} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";

const metricProcessName = "ADTA_DEVICE_DETAILS";

export function fetchAdtaDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: ADTA_ASSET_TYPE
    }
    getAdtaDeviceDetails(dispatcher, request)
}

export function deleteAdtaDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: INACTIVE
    }
    setAssetLabelInactiveAdtaDeviceDetails(dispatcher, request)
}

export function deleteAdtaDeviceConfigDetails(dispatcher, mac, bayId) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        }
    }
    updateAdtaDeviceConfigDetails(dispatcher, request, bayId)
}

export function deleteAdtaDeviceTestPackageDetails(dispatcher, mac, scannables) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        }
    }
    updateAdtaDeviceTestPackageDetails(dispatcher, request, scannables)
}

export function setAdtaDeviceConfigDetails(dispatcher, sorterConfig, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        }
    }
    addAdtaDeviceConfigDetails(dispatcher, request, sorterConfig)
}

export function setAdtaDeviceTestPackageDetails(dispatcher, sorterTestPackage, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        }
    }
    addAdtaDeviceTestPackageDetails(dispatcher, request, sorterTestPackage)
}

export function setAdtaDeviceDetails(dispatcher, stateValues) {
    const request = convertTableJsonToAsset(stateValues, ADTA_ASSET_TYPE, ACTIVE);
    addAdtaDeviceDetails(dispatcher, request)
}

export function updateAdtaDeviceDetails(dispatcher, stateValues) {
    const request = convertTableJsonToAsset(stateValues, ADTA_ASSET_TYPE, ACTIVE);
    updateAdtaAsset(dispatcher, request);
}

export const updateAdtaSorterConfig = (result, sorterConfig) => {
    const temp = [sorterConfig]
    if (checkNullAndUndefinedAttribute(result.assetDetails.assetAttributes.sorterConfig)) {
        for (const object of JSON.parse(result.assetDetails.assetAttributes.sorterConfig)) {
            if (object.bayId !== sorterConfig.bayId) {
                temp.push(object)
            }
        }
    }
    result.assetDetails.assetAttributes.sorterConfig = JSON.stringify(temp)
    return result;
}

export const updateAdtaTestPackageConfig = (result, sorterTestPackage) => {
    const temp = [sorterTestPackage]
    const tempKey = sorterTestPackage.scannables.join(';');
    if (checkNullAndUndefinedAttribute(result.assetDetails.assetAttributes.sorterTestPackage)) {
        for (const object of JSON.parse(result.assetDetails.assetAttributes.sorterTestPackage)) {
            const key = object.scannables.join(';');
            if (key !== tempKey) {
                temp.push(object)
            }
        }
    }
    result.assetDetails.assetAttributes.sorterTestPackage = JSON.stringify(temp)
    return result;
}

export const updateAdtaDeviceConfigList = async (result, bayId, dispatcher) => {
    const temp = []
    if (bayId !== ALL_CONFIG) {
        if (checkNullAndUndefinedAttribute(result.assetDetails.assetAttributes.sorterConfig)) {
            for (const key of JSON.parse(result.assetDetails.assetAttributes.sorterConfig)) {
                if (key.bayId !== bayId)
                    temp.push(key)
            }
        }
    }
    result.assetDetails.assetAttributes.sorterConfig = JSON.stringify(temp)
    const responseSetAssetStatus = await setAssetStatus(result.assetDetails.assetLabel, ACTIVE);
    if (responseSetAssetStatus.status !== 200) {
        alert(ALERT_ASSET_STATUS_MESSAGE);
    } else if (responseSetAssetStatus.status === 200) {
        const responseUpdateAsset = await updateAsset(result);
        if (responseUpdateAsset.status !== 200) {
            alert(ALERT_UPDATE_ASSET_MESSAGE);
        }
    }
    fetchAdtaDeviceDetails(dispatcher)
}

export const updateAdtaDeviceTestPackageList = (result, scannables) => {
    const temp = []
    if (checkNullAndUndefinedAttribute(result.assetDetails.assetAttributes.sorterTestPackage)) {
        for (const object of JSON.parse(result.assetDetails.assetAttributes.sorterTestPackage)) {
            const key = object.scannables.join(';');
            if (key !== scannables) {
                temp.push(object)
            }
        }
    }
    result.assetDetails.assetAttributes.sorterTestPackage = JSON.stringify(temp)
    return result;
}

export const extractAdtaDeviceList = (result) => {
    let model = {
        adtaDeviceInformation: {},
        sorterConfig: [],
        sorterTestPackageConfig: [],
        macAddressArray: []
    }
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((adtaDeviceDetail) => {
            if (adtaDeviceDetail.assetStatus === ACTIVE) {
                model.macAddressArray.push(adtaDeviceDetail.assetAttributes.mac)
                const sorterConfigModel = {
                    sorterConfig: []
                }
                const sorterTestPackageModel = {
                    sorterTestPackage: []
                }
                if ("sorterConfig" in adtaDeviceDetail.assetAttributes) {
                    const sorterConfigValueJson = JSON.parse(adtaDeviceDetail.assetAttributes.sorterConfig);
                    sorterConfigValueJson.forEach((sorterConfigValue) => {
                        const tempObj = {
                            bayId: sorterConfigValue.bayId,
                            type: sorterConfigValue.installation.type,
                            locations: sorterConfigValue.installation.locations
                        }
                        sorterConfigModel.sorterConfig.push(tempObj)
                    })
                }
                if ("sorterTestPackage" in adtaDeviceDetail.assetAttributes) {
                    const sorterTestPackageInformationValueJson = JSON.parse(adtaDeviceDetail.assetAttributes.sorterTestPackage);
                    sorterTestPackageInformationValueJson.forEach((sorterTestPackageInformationValue) => {
                        const tempObj = {
                            scannables: sorterTestPackageInformationValue.scannables,
                            sortZone: sorterTestPackageInformationValue.sortZone
                        }
                        sorterTestPackageModel.sorterTestPackage.push(tempObj)
                    })
                }
                const mac = adtaDeviceDetail.assetAttributes.mac;
                const id = JSON.parse(adtaDeviceDetail.assetAttributes.deviceConfig).id;
                model.adtaDeviceInformation[mac] = {
                    name: adtaDeviceDetail.assetAttributes.name,
                    mac: adtaDeviceDetail.assetAttributes.mac,
                    ip: adtaDeviceDetail.assetAttributes.ip,
                    id: id,
                    port: adtaDeviceDetail.assetAttributes.port,
                    assetStatus: LOADING_STRING,
                    deviceType: adtaDeviceDetail.assetAttributes.deviceType,
                    assetType: adtaDeviceDetail.assetType,
                }
                model.sorterConfig[mac] = sorterConfigModel.sorterConfig;
                model.sorterTestPackageConfig[mac] = sorterTestPackageModel.sorterTestPackage;
            }
        });
    }
    return model;
}

async function getAdtaDeviceStatusDetails(dispatcher, model) {
    const request = {
        nodeId: getNodeId(),
        macAddressList: model.macAddressArray
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_ADTA_STATUS);
    getAPIGatewayDataFromParent(args).then(response => {
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getAdtaDeviceStatusDetails", true);
            mergeStatusToModel(response, model)
            dispatcher({type: "RECEIVE_DATA", data: model});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getAdtaDeviceStatusDetails", false);
            request.macAddressList.forEach((macAddress) => {
                model.adtaDeviceInformation[macAddress].assetStatus = LOADING_FAILED
            })
            dispatcher({type: "RECEIVE_DATA", data: model});
        }
    })
}

async function getAdtaDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    getAssets(request.nodeId, request.assetType).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getAdtaDeviceDetails", true);
            getAdtaDeviceStatusDetails(dispatcher, extractAdtaDeviceList(result))
        } else {
            logOperationalMetric(startTime, metricProcessName, "getAdtaDeviceDetails", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

async function setAssetLabelInactiveAdtaDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteAdtaDeviceDetails", true);
            fetchAdtaDeviceDetails(dispatcher);
        } else {
            logOperationalMetric(startTime, metricProcessName, "deleteAdtaDeviceDetails", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

async function addAdtaDeviceConfigDetails(dispatcher, request, sorterConfig) {
    // Get existing configuration
    const getAssetResult = await getAssetByAssetLabel(request.assetLabel);

    // Merge current configuration into existing configuration and update
    const startTime = Date.now();
    const updatedAsset = updateAdtaSorterConfig(getAssetResult.data.asset, sorterConfig, dispatcher)
    const updateResult = await updateAsset(updatedAsset);
    const isUpdateSuccess = updateResult.status === 200;
    if (!isUpdateSuccess) {
        alert(ALERT_UPDATE_ASSET_MESSAGE);
    }
    fetchAdtaDeviceDetails(dispatcher)

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "getAdtaDeviceConfigDetails", isUpdateSuccess);
}

async function addAdtaDeviceTestPackageDetails(dispatcher, request, sorterTestPackage) {
    // Get existing configuration
    const getAssetResult = await getAssetByAssetLabel(request.assetLabel);

    // Merge current configuration into existing configuration and update
    const startTime = Date.now();
    const updatedAsset = updateAdtaTestPackageConfig(getAssetResult.data.asset, sorterTestPackage);
    const updateResult = await updateAsset(updatedAsset);
    const isUpdateSuccess = updateResult.status === 200;
    if (!isUpdateSuccess) {
        alert(ALERT_UPDATE_ASSET_MESSAGE);
    }
    fetchAdtaDeviceDetails(dispatcher)

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "addAdtaDeviceTestPackageDetails", isUpdateSuccess);
}

async function updateAdtaDeviceConfigDetails(dispatcher, request, bayId) {
    const startTime = Date.now();
    getAssetByAssetLabel(request.assetLabel).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "updateAdtaDeviceConfigDetails", true);
            dispatcher({
                type: "RECEIVE_DATA",
                data: updateAdtaDeviceConfigList(result.data.asset, bayId, dispatcher)
            });
        } else {
            logOperationalMetric(startTime, metricProcessName, "updateAdtaDeviceConfigDetails", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

async function updateAdtaDeviceTestPackageDetails(dispatcher, request, scannables) {
    // Get existing configuration
    const getAssetResult = await getAssetByAssetLabel(request.assetLabel);

    // Update asset
    const startTime = Date.now();
    const updatedAsset = updateAdtaDeviceTestPackageList(getAssetResult.data.asset, scannables);
    const responseUpdateAsset = await updateAsset(updatedAsset);
    if (responseUpdateAsset.status !== 200) {
        alert(ALERT_UPDATE_ASSET_MESSAGE);
    }
    fetchAdtaDeviceDetails(dispatcher);

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "updateAdtaDeviceTestPackageDetails", true);
}

async function addAdtaDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    addAsset(request).then(async result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "addAdtaDeviceDetails", true);
        } else {
            logOperationalMetric(startTime, metricProcessName, "addAdtaDeviceDetails", false);
            // 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
            // UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                alert(ALERT_ASSET_STATUS_MESSAGE);
            } else if (responseSetAssetStatus.status === 200) {
                const responseUpdateAsset = await updateAsset(request);
                if (responseUpdateAsset.status !== 200) {
                    alert(ALERT_UPDATE_ASSET_MESSAGE);
                }
            }
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
        fetchAdtaDeviceDetails(dispatcher)
    });
}

async function updateAdtaAsset(dispatcher, request) {
    // Set asset to active first
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
    if (setAssetStatusResponse.status !== 200) {
        alert(ALERT_ASSET_STATUS_MESSAGE);
        fetchAdtaDeviceDetails(dispatcher);
        return;
    }
    // Update asset details
    const startTime = Date.now();
    const updateAssetResponse = await updateAsset(request);
    const isSuccess = updateAssetResponse.status === 200;
    logOperationalMetric(startTime, metricProcessName, "updateAdtaDeviceDetails", isSuccess);
    fetchAdtaDeviceDetails(dispatcher);
}

function mergeStatusToModel(response, model) {
    if ("data" in response && "adtaStatusList" in response.data) {
        response.data.adtaStatusList.forEach((singleAdtaDeviceStatusDetail) => {
            model.adtaDeviceInformation[singleAdtaDeviceStatusDetail.mac].assetStatus = singleAdtaDeviceStatusDetail.status
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/network/AdtaDeviceOverviewNetworkAPI.js